import { jsx as i, jsxs as e } from "react/jsx-runtime";
import { forwardRef as o } from "react";
import { NavLink as n } from "react-router-dom";
import { usePageContext as r } from "../../providers/PageProvider.js";
import t from "@mui/joy/Stack";
import { Container as l, NavLink as d, TabSkeleton as a, Wrapper as s } from "./styled.js";
const c = ({ links: e2, loading: o2 }) => i(l, { disabled: o2, children: e2.map(({ title: e3, path: r2, isHidden: t2, className: l2, component: s2 = n, onClick: c2 }) => i(d, { className: l2, to: r2, end: s2 === n || void 0, component: s2, disabled: o2, display: t2 ? "none" : "inline-flex", relative: "path", onClick: c2, children: i(a, { variant: "text", level: "body-sm", loading: o2, children: e3 }) }, e3)) }), m = o(({ links: o2, containerId: n2 = "section-right", children: l2 }, d2) => {
  const { loading: a2 } = r();
  return e(s, { children: [i(c, { links: o2, loading: a2 }), i(t, { ref: d2, id: n2, direction: "row", flex: 1, justifyContent: "flex-end", children: l2 })] });
});
export {
  c as NavLinkTabs,
  m as NavLinkTabsContainer
};
//# sourceMappingURL=index.js.map
